import React from 'react'
import '../css/Cources.css'
import CourceImage from './CourceImage'
import CourceChapters from './CourceChapters'

const Cources = () => {
  return (
    <div className='w-100 h-100'>
      <CourceImage />
      <CourceChapters />
    </div>
  )
}

export default Cources